<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12" role="region" aria-label="Dealer or Brand Section">
                <slot name="top-section"></slot>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8" role="region" aria-label="News Section">
                <slot name="left-content"></slot>
            </div>
            <div class="col-md-4" role="region" aria-label="Events Section">
                <slot name="right-content"></slot>
            </div>
        </div>
    </div>
</template>
<script>

</script>